class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupPanelHover();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  setupPanelHover() {
    const triggers = this.querySelectorAll('[data-mega-trigger]');
    if (!triggers.length) return;

    const allPanels = this.querySelectorAll('.mega-menu__list-l3');
    const allItems = this.querySelectorAll('.mega-menu__item-l2');

    const activate = (trigger) => {
      const panelId = 'mega-panel-' + trigger.dataset.megaTrigger;
      allPanels.forEach((p) => p.hidden = true);
      allItems.forEach((li) => li.classList.remove('is-active'));
      const panel = this.querySelector('#' + panelId);
      if (panel) panel.hidden = false;
      trigger.closest('.mega-menu__item-l2')?.classList.add('is-active');
    };

    // Show first item with children by default when menu opens
    this.mainDetailsToggle.addEventListener('toggle', () => {
      if (this.mainDetailsToggle.open) {
        const first = triggers[0];
        if (first) activate(first);
      }
    });

    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => activate(trigger));
      trigger.addEventListener('focus', () => activate(trigger));
    });
  }
}

customElements.define('header-menu', HeaderMenu);
